import React from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import DoneIcon from '@material-ui/icons/Done';
import ClearIcon from '@material-ui/icons/Clear';
import Link from '../../misc/Link';

const useStyles = makeStyles((theme: any) => {
  const itemPrefixWidth = theme.spacing(4);
  return {
    root: {
      display: 'flex',
      width: '100%',
      paddingTop: theme.spacing(1),
      paddingBottom: theme.spacing(2),
    },
    item: {
      width: itemPrefixWidth,
    },
    itemLink: {
      maxWidth: `calc(100% - ${itemPrefixWidth}px)`,
    },
    verified: {
      color: theme.palette.status.active,
      marginLeft: theme.spacing(-0.5),
    },
    notVerified: {
      color: theme.palette.error.main,
      marginLeft: theme.spacing(-0.5),
    },
  };
});

export default function Item(props) {
  const classes = useStyles();
  const {
    number,
    label,
    accountsItem = false,
    accountsVerified = false,
  } = props;

  return (
    <div className={classes.root}>
      {!accountsItem && (
        <span className={classes.item}>
          {props.bold ? <b>{number}</b> : number}
        </span>
      )}
      {accountsItem && (
        <span className={classes.item}>
          {accountsVerified ? (
            <DoneIcon className={classes.verified} />
          ) : (
            <ClearIcon className={classes.notVerified} />
          )}
        </span>
      )}
      <Link
        href="/account"
        disabled={!accountsItem ? true : accountsVerified}
        className={classes.itemLink}
      >
        {label}
      </Link>
    </div>
  );
}
